var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronrightcompact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9004 19.9277L14.6641 12.9941C14.8008 12.6621 14.957 12.252 14.957 11.9297C14.957 11.6172 14.8008 11.1973 14.6641 10.875L11.9004 3.94141C11.793 3.64844 11.5391 3.48242 11.2754 3.48242C10.8555 3.48242 10.5332 3.79492 10.5332 4.21484C10.5332 4.42969 10.6504 4.71289 10.7188 4.9082L13.5215 11.9297L10.7188 18.9609C10.6504 19.1562 10.5332 19.4297 10.5332 19.6543C10.5332 20.0742 10.8555 20.3867 11.2754 20.3867C11.5391 20.3867 11.793 20.2207 11.9004 19.9277Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronrightcompact);
export default __webpack_public_path__ + "static/media/Chevron right compact.7dd66d94fe9790770d136570e0e9385c.svg";
export { ForwardRef as ReactComponent };